import React, { ButtonHTMLAttributes } from 'react';
import styled from 'astroturf/react';

export const Container = styled.button<{
  color: PillProps['color'];
  active: PillProps['active'];
}>`
  @import 'stylesheets/design_system/font';
  @import 'stylesheets/design_system/_deprecated_grid.scss';
  @import 'stylesheets/design_system/_color.scss';

  @include sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;

  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 15px;
  background: transparent;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  text-wrap: none;

  &.color-primary:not(:disabled) {
    color: $ds-primary-blue-active;
    border: 1px solid #b4c7e8;

    &:hover {
      background: #eef2f9;
      border: 1px solid #9bb5e0;
    }

    &:active,
    &.active {
      color: #082f75;
      background: #e6ecf7;
      border: 1px solid #e6ecf7;
    }

    &:focus-visible {
      padding: 0 13px;
      background: #eef2f9;
      border: 3px solid #b4c7e8;
    }
  }

  &.color-gray:not(:disabled) {
    color: $ds-gray-dark;
    border: 1px solid #dddde2;

    &:hover {
      color: $ds-black;
      background: #f8f8fb;
      border: 1px solid #c8c8cf;
    }

    &:active,
    &.active {
      color: $ds-black;
      background: #ebebee;
      border: 1px solid #b1b1ba;
    }

    &:focus-visible {
      padding: 0 13px;
      color: $ds-black;
      background: #f8f8fb;
      border: 3px solid #b4c7e8;
    }
  }

  &:disabled {
    color: #b1b1ba;
    border: 1px solid #dddde2;
  }
`;

export type PillProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: 'primary' | 'gray';
  active?: boolean;
};

export const Pill: React.FC<PillProps> = ({
  color = 'primary',
  active = false,
  children,
  ...props
}) => {
  return (
    <Container color={color} active={active} {...props}>
      {children}
    </Container>
  );
};
